const MIN_ADULT_AGE = 18;

export const requiresGuardianForTeen = (dateOfBirth: string | null | undefined) => {
  if (!dateOfBirth) {
    return true;
  }

  const birthDate = new Date(`${dateOfBirth}T00:00:00`);
  if (Number.isNaN(birthDate.getTime())) {
    return true;
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth()
    || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

  if (!hasHadBirthdayThisYear) {
    age -= 1;
  }

  return age < MIN_ADULT_AGE;
};

export const buildGuardianSetupHref = (returnTo = "/gigs") => {
  const params = new URLSearchParams({
    setup: "before-apply",
    returnTo,
  });
  return `/teen/guardians?${params.toString()}`;
};
